export default __webpack_public_path__ + "static/media/icon-iot-round.fa15dea7.svg";